import { render, staticRenderFns } from "./UpgraderFilterSearch.vue?vue&type=template&id=566967a7&scoped=true"
import script from "./UpgraderFilterSearch.vue?vue&type=script&lang=js"
export * from "./UpgraderFilterSearch.vue?vue&type=script&lang=js"
import style0 from "./UpgraderFilterSearch.vue?vue&type=style&index=0&id=566967a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566967a7",
  null
  
)

export default component.exports